import { Box } from "@mui/material";
import React, { useEffect } from "react";
import loginimage from "../../../assest/images/crmlog.jpg";
import SignInputField from "./SignInputField";
import logo from "../../../assest/images/mefood-fav.png";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../../../layoutcontainers/PageLayout";
const SignIn = () => {

  return (
    <PageLayout disableFooter showNavbar>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          borderRadius: "20px",
          overflow: "hidden",

          maxWidth: "900px",
        }}
      >
        <Box sx={{ width: "60%", height: "100% !imporatant" }}>
          <img
            src={loginimage}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "fill",
              objectPosition: "center",
            }}
          />
        </Box>
        <Box sx={{ width: "40%", height: "100%" }}>
          <Box
            sx={{
              backgroundColor: "#2a9941",
              padding: "55px 0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ textAlign: "center", position: "relative" }}>
              <h5 style={{ color: "white" }}>Welcome Back !</h5>
              <p style={{ fontSize: "14px", color: "white" }}>
                Sign in to continue to Me Food !
              </p>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",

                  position: "absolute",
                  zIndex: "10",

                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    background: "white",

                    zIndex: "10",

                    overflow: "hidden",
                  }}
                >
                  <img
                    src={logo}
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "contain",
                      objectPosition: "center",
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              padding: "0px 15px",
              paddingTop: "80px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SignInputField />
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default SignIn;
